<template>
  <div class="container about">
    <!-- <h1>这是随时考页面</h1> -->

    <div class="row">
      <div class="col-12">
        <div class="panel">
          <div class="col-8 col-pd0">
            <h1>云端随时考</h1>
            <p>从评价者角度出发、从云端获取评分表，随时录入（可拍照身份证录入）考生信息，随时开始考评，系统自动汇总评价者所有考评记录。</p>
            <div class="app-downlod clearfix">
              <div class="qrcode pull-left">
                <a class="group1" href="img/download/download-qrcode.png" title="请扫描下载二维码"><img src="img/download/download-qrcode.png" alt="请扫描下载二维码"></a>
              </div>
              <div class="pull-left">
                <button class="btn btn-android" v-on:click="onClickBtnAndroid"><img src="@/assets/icon-android-light.png" alt="安卓下载" height="25"> 安卓下载</button><br>
                <button class="btn btn-ios" v-on:click="onClickBtnIos"><img src="@/assets/icon-apple-light.png" alt="IOS下载" height="25"> IOS下载</button>
              </div>
            </div>

            <div class="hr"></div>
          </div>
          <div class="col-4 col-pd0">
            <div class="login-box">
              <div class="login-title">账号登录</div>
              <input type="text" placeholder="手机号/账号" id="user_name" autocomplete="off">
              <input type="password" placeholder="密码" class="mt30" id="password" >
              <button class="btn btn-login" v-on:click="onLogin">登录</button>
              <div class="mt10 text-center"><small class="text-grey">※ 请下载app进行注册和找回密码</small></div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-8 col-pd-right0">
        <div class="panel">
          <h1>云端随时考</h1>
          <p>从评价者角度出发、从云端获取评分表，随时录入（可拍照身份证录入）考生信息，随时开始考评，系统自动汇总评价者所有考评记录。</p>
          <div class="app-downlod clearfix">
            <div class="qrcode pull-left">
              <a class="group1" href="img/download/download-qrcode.png" title="请扫描下载二维码"><img src="img/download/download-qrcode.png" alt="请扫描下载二维码"></a>
            </div>
            <div class="pull-left">
              <button class="btn btn-android"><img src="@/assets/icon-android-light.png" alt="安卓下载" height="25"> 安卓下载</button><br>
              <button class="btn btn-ios"><img src="@/assets/icon-apple-light.png" alt="IOS下载" height="25"> IOS下载</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 col-pd-left0">
        <div class="panel">
          <div class="login-box">
            <div class="login-title">账号登录</div>
            <input type="text" placeholder="手机号/账号">
            <input type="password" placeholder="密码" class="mt30">
            <button class="btn btn-login">登录</button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import "jquery-colorbox/example3/colorbox.css";
import "jquery-colorbox/jquery.colorbox-min.js";
import "jquery-colorbox/i18n/jquery.colorbox-zh-CN.js";

export default {
  name: "anytime-examination",
  mounted: function() {
    $(".group1").colorbox({rel: "group1", maxWidth:"75%", maxHeight:"75%"});
  },
  methods: {
    onLogin: function() {
      let name = $("#user_name").val();
      let pass = $("#password").val();

      $.ajax({
        type: "POST",
        data: { "UserName": name, "password": pass },
        url: "/Basic_Index/CheckUserLogin",
        datatype: "json",
        success: function (result) {
          let obj = eval(result);

          if (obj.success == true) {
              window.location.href = obj.url;
          } else {
              alert(obj.msg);
          }
        }
      });
    },
    onClickBtnAndroid: function() {
      window.open("https://a.app.qq.com/o/simple.jsp?pkgname=com.tellyes.handosce&fromcase=40003");
    },
    onClickBtnIos: function() {
      window.open("https://a.app.qq.com/o/simple.jsp?pkgname=com.tellyes.handosce&fromcase=40003");
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .panel {
  position: relative;
  height: 70vh;
  min-height: 500px;

  .app-downlod {
    margin-top: 50px;

    .qrcode {
      margin-right: 50px;
      width: 150px;

      img {
        width: 100%;
      }
    }

    button {
      margin-top: 22px;
      width: 180px;
      height: 40px;
      border-radius: 20px;
      padding: 0 30px;
      background-color: #2478e6;
      color: #fff;
      font-size: 20px;
      line-height: 40px;
      text-align: left;

      img {
        vertical-align: -10%;
      }

      &.btn-android {
        &:hover { background-color: #226bcc; }
      }

      &.btn-ios {
        background-color: #ee7f1a;
        &:hover { background-color: #e0791b; }
      }
    }
  }

  .login-box {
    .login-title {
      height: 30px;
      border-bottom: 2px solid #2478e6;
      color: #2478e6;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
    }

    input, button {
      margin-top: 50px;
      width: 100%;
      border: 1px solid #ccc;
    }

    input {
      height: 45px;
      border-radius: 5px;
      padding: 5px 10px;
      line-height: 45px;

      // -webkit-input-placeholder,-ms-input-placeholder,-moz-placeholder,-moz-placeholder
      &::placeholder {
        color: #ccc;
        font-size: 16px;
      }
    }

    button {
      height: 45px;
      border-radius: 5px;
      background-color: #2478e6;
      color: #fff;
      font-size: 20px;
      line-height: 45px;

      &.btn-login {
        &:hover { background-color: #226bcc; }
      }
    }
  }
}

/deep/ .panel .col-8 {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 0;
  padding: 60px 100px;

  .hr {
    position: absolute;
    top: 20px;
    bottom: 20px;
    right: 0;
    width: 2px;
    background-image: linear-gradient(to bottom, #f8f8f8 0%, #ddd 50%,#f8f8f8 100%);;
  }
}

/deep/ .panel .col-4 {
  position: absolute;
  top: 20px;
  bottom: 20px;
  right: 0;
  padding: 100px 50px;
}

// /deep/ .col-8 .panel {
//   padding: 60px 100px;
// }

// /deep/ .col-4 .panel {
//   padding: 100px 50px;
// }
</style>
